<template>
	<div class="pins-item-footer">
		<div class="pins-item-footer__value">{{ value }}</div>
		<div class="pins-item-footer__title">{{ title }}</div>
	</div>
</template>

<script>
export default {
	name: 'pins-item-footer',
	props: {
		title: {
			type: String,
			default: ''
		},
		value: {
			type: String|Number,
			default: ''
		}
	}
}
</script>

<style scoped>
.pins-item-footer {
	display: flex;
	padding: 0 20px;
	flex-direction: column;
	flex: 1;
	align-items: center;
	justify-content: center;
}
.pins-item-footer__title {
	font-size: 12px;
	color: #aaa;
}
.pins-item-footer__value {
	color: #333;
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/modules/pins/PinsItemFooter.vue